module.exports = __webpack_public_path__ + "assets/img/D5.58eb031a.png";